import { render, staticRenderFns } from "./naj-modal.vue?vue&type=template&id=a18b327c&scoped=true&"
import script from "./naj-modal.vue?vue&type=script&lang=js&"
export * from "./naj-modal.vue?vue&type=script&lang=js&"
import style0 from "./naj-modal.vue?vue&type=style&index=0&id=a18b327c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18b327c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
